module.exports = __webpack_public_path__ + "img/whats-new-53-colordrop_16x9_jp_poster.15fd2bc.jpg";